export default "__VITE_ASSET__CliQC2Ld__"